(function () {
  function removeStandaloneStarRatings(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      var containsStar = /[★☆]/.test(value);
      var containsOnlyStarsAndSpacing = value.replace(/[★☆\s\u200b-\u200d\ufeff]/g, '') === '';
      if (containsStar && containsOnlyStarsAndSpacing) nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      textNode.nodeValue = '';
      if (textNode.parentElement && !textNode.parentElement.textContent.trim()) {
        textNode.parentElement.hidden = true;
        textNode.parentElement.setAttribute('aria-hidden', 'true');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var article = document.querySelector('.post-content') || document.querySelector('#bloggle_rte');
    if (article && article.querySelector('.obp-mag-story-note')) {
      removeStandaloneStarRatings(article);
    }
  });
})();
